import axios from "axios";
import moment from "moment"
import { string } from "yup";

const PdfAxios = async function (props = {}) {
  var gett = localStorage.getItem("isloggedIn");
  var customerNo = localStorage.getItem("customerNumber");
  var userId = localStorage.getItem("userId");
  var locales = localStorage.getItem("locales") === "en" ? "en-IN" : "pt-Br"

  let congData = JSON.stringify({
    customerNumber: customerNo,
    userId: userId,
    customer_no: +customerNo,
    user_id: +userId,
    customerNo: +customerNo,
    searchTerm: props.searchTerm,
    ...props.readItems
  });

  const apiURL = props.completeURL
    ? `${props.completeURL}`
    : props.envBase ? `${props.envBase}/${props.url}` : `${process.env.REACT_APP_MASTER_API}/${props.url}`;
  // : `http://dev-scctgateway.elixia.tech/masters/${props.url}`;
if (props.PDFURL) {
  let apiPDFURL =  props.PDFURL
    try {
      return new Promise((resolve, reject) => {
        var config = {
          method: "get",
          url: apiPDFURL,
          responseType: 'blob',
          headers: {
            Authorization: `${gett}`,
            // "Content-Disposition": 'attachment; filename="filename.pdf',
            // "Accept-Language": locales
          },
        };

        axios(config)
          .then(function (response) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a")
            link.href = url
            const type = response.data.type
            let file_name = ""
            console.log("FILE TYPE : ", type);
            if (type === "application/vnd.ms-excel") { file_name = "file.xls" }
            else if (type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") { file_name = "file.xlsx" }
            else if(response.config.url.includes(".jpg")){file_name = "file.jpg"}
            else if(response.config.url.includes(".png")){file_name = "file.png"}
            else { file_name = "file.pdf" }
            link.setAttribute('download', file_name)
            document.body.appendChild(link)
            link.click();
            // console.log(JSON.stringify(response.data));
            // resolve(response);
          })
          .catch(function (error) {
            console.log("Erro PDF =====>", error.response);
            reject(error.response);
          });
      });
    } catch (e) {
      return console.log("ErrorRead", e);
    }
  }
  else if (props.completeURL) {
    try {
      return new Promise((resolve, reject) => {
        var config = {
          method: "get",
          url: apiURL,
          responseType: 'blob',
          headers: {
            Authorization: `${gett}`,
            // "Content-Disposition": 'attachment; filename="filename.pdf',
            // "Accept-Language": locales
          },
          data: congData,
          params: {
            customer_no: +customerNo,
            user_id: +userId,
            customerNo: +customerNo,
          },
        };

        axios(config)
          .then(function (response) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a")
            link.href = url
            const type = response.data.type
            let file_name = ""
            console.log("FILE TYPE : ", type);
            if (type === "application/vnd.ms-excel") { file_name = "file.xls" }
            else if (type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") { file_name = "file.xlsx" }
            else { file_name = "file.pdf" }
            link.setAttribute('download', file_name)
            document.body.appendChild(link)
            link.click();
            // console.log(JSON.stringify(response.data));
            // resolve(response);
          })
          .catch(function (error) {
            console.log("Erro PDF =====>", error.response);
            reject(error.response);
          });
      });
    } catch (e) {
      return console.log("ErrorRead", e);
    }
  } else {
    try {
      return new Promise((reslove, reject) => {
        axios
          .post(apiURL, congData, {
            headers: {
              "content-type": "application/json",
              Authorization: `${gett}`,
              "Accept-Language": locales
            },
          })
          .then((res) => {
            if (res.data.status === 200 && res.data.resultSet !== "") {
              const resultSet = res.data.resultSet.map(rs => {
                try {
                  if (rs.hasOwnProperty('createdOn')) {
                    const createdOn = moment(rs.createdOn).isValid() ? moment(rs.createdOn).format("DD-MM-YY | HH:mm") : "N/A"
                    rs.createdOn = createdOn
                  }
                  if (rs.hasOwnProperty('updatedOn')) {
                    const updatedOn = moment(rs.updatedOn).isValid() ? moment(rs.updatedOn).format("DD-MM-YY | HH:mm") : "N/A"
                    rs.updatedOn = updatedOn
                  }
                  rs.updatedBy = rs.updatedBy || "N/A"
                } catch (error) {
                  console.log("Date Format Error")
                }
                return rs;
              })
              res.data.resultSet = resultSet
              reslove(res);
            } else {
              reject(res);
            }
          })
          .catch((err) => {
            console.log("Error PDF =====>", err)
            reject(err);
          });
      });
    } catch (e) {
      return console.log("ErrorRead", e);
    }
  }
};

export default PdfAxios;
